// Formato de números estilo español: 1.234.567,89
export const fmt = (v, decimals = 2) => {
  const n = parseFloat(v);
  if (isNaN(n)) return '0';
  return n.toLocaleString('es-ES', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

// Formato compacto sin decimales innecesarios: 1.234,5 o 1.234
export const fmtCompact = (v) => {
  const n = parseFloat(v);
  if (isNaN(n)) return '0';
  return n.toLocaleString('es-ES', { maximumFractionDigits: 2 });
};

// Solo enteros con separador
export const fmtInt = (v) => {
  const n = parseFloat(v);
  if (isNaN(n)) return '0';
  return Math.round(n).toLocaleString('es-ES');
};
